import { memo } from 'preact/compat'
import { useContext, useRef, useEffect } from 'preact/hooks'
import { AppContext } from '../main'
import { loadDispatcher } from '../utils'

const ActionCard = () => {
  const context = useContext(AppContext)
  const headersCount = context ? context.headersCount : null
  const acRef = useRef(null)

  loadDispatcher.loadCallback ??= data => {
    if (headersCount === 1 && data.sections.length && data.sections[0].type === 'Separator') {
      // hide single separator if it comes first
      var sheet = new CSSStyleSheet()
      sheet.replaceSync(`[data-type="Separator"] { display: none }`)
      acRef.current.shadowRoot.adoptedStyleSheets.push(sheet)
    }
  }

  return <action-cards ref={acRef}></action-cards>
}

export default memo(ActionCard)
